function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14 18H4C1.8 18 0 16.2 0 14V4C0 1.8 1.8 0 4 0H14C16.2 0 18 1.8 18 4V14C18 16.2 16.2 18 14 18Z",
  fill: "#E21E1E"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 10.2C13.5 12.6 12.1 15 9 15C5.9 15 4.5 12.6 4.5 10.2C4.5 6.8 6.9 3 9 3C11.1 3 13.5 6.8 13.5 10.2Z",
  fill: "white"
});

function SvgMtslogo({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0IDE4SDRDMS44IDE4IDAgMTYuMiAwIDE0VjRDMCAxLjggMS44IDAgNCAwSDE0QzE2LjIgMCAxOCAxLjggMTggNFYxNEMxOCAxNi4yIDE2LjIgMTggMTQgMThaIiBmaWxsPSIjRTIxRTFFIi8+CjxwYXRoIGQ9Ik0xMy41IDEwLjJDMTMuNSAxMi42IDEyLjEgMTUgOSAxNUM1LjkgMTUgNC41IDEyLjYgNC41IDEwLjJDNC41IDYuOCA2LjkgMyA5IDNDMTEuMSAzIDEzLjUgNi44IDEzLjUgMTAuMloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgMtslogo as ReactComponent };